import { AssetService } from 'app/ts/services/AssetService';
import * as Interface_DTO_Draw from 'app/ts/Interface_DTO_Draw';
import * as Client from 'app/ts/clientDto/index';
import { Side, VerticalPosition } from '@ClientDto/Enums';

export class CorpusService {
  public static readonly Name = 'corpusService';

  constructor(private readonly assetService: AssetService) {}

  public static calculateCorpusJoints(
    cabinetSection: Client.CabinetSection,
  ): CorpusService.Joint[] {
    let flexItemHeight: number = 0;
    let flexHeightItem = cabinetSection.corpus.itemsTop.find(
      (item) => item.isFlexHeight,
    );
    if (flexHeightItem) {
      flexItemHeight = flexHeightItem.Height;
    }

    let topJointsFlex = cabinetSection.corpus.jointsTopFlexHeightItems.map(
      (j) => {
        return <CorpusService.Joint>{
          X:
            j +
            cabinetSection.corpus.topDeductionLeft +
            cabinetSection.corpus.deductionForFlexHeightItem[Side.Left][
              VerticalPosition.Top
            ],
          Y: cabinetSection.Height - flexItemHeight,
          height: flexItemHeight,
        };
      },
    );

    let fixItemHeight: number = 0;
    let fixHeightItem = cabinetSection.corpus.itemsTop.find(
      (item) => !item.isFlexHeight,
    );
    if (fixHeightItem) {
      fixItemHeight = fixHeightItem.Height;
    }

    let topJoints = cabinetSection.corpus.jointsTop.map((j) => {
      return <CorpusService.Joint>{
        X: j + cabinetSection.corpus.topDeductionLeft,
        Y: cabinetSection.Height - (flexItemHeight + fixItemHeight),
        height: fixItemHeight,
      };
    });

    let bottomJoints = cabinetSection.corpus.jointsBottom.map((j) => {
      let height = Math.max(
        0,
        ...cabinetSection.corpus.itemsBottom.map((i) => i.Height),
      );
      return <CorpusService.Joint>{
        X: j + cabinetSection.corpus.bottomDeductionLeft,
        Y: 0,
        height: height,
      };
    });

    return topJointsFlex.concat(topJoints, bottomJoints);
  }
}

export module CorpusService {
  export interface Joint extends Interface_DTO_Draw.Vec2d {
    height: number;
  }
}
